import React from "react";
import {Button} from "@/shared/components/ui/button";

interface PaginatorButtonProps {
    onClick: () => void;
    disabled?: boolean;
    icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
}

export const PaginatorButton: React.FC<PaginatorButtonProps> = ({onClick, disabled, icon}) => (
    <Button
        onClick={onClick}
        disabled={disabled}
        className="p-1 disabled:opacity-50 disabled:pointer-events-none"
    >
        {React.isValidElement(icon)
            ? React.cloneElement(icon, {
                className: `${icon.props.className} transition-colors duration-150 ${
                    disabled ? "" : "hover:stroke-blue-400"
                }`,
            })
            : icon}
    </Button>
);
